import { Mapper } from "master-locations-library/master-locations-library/src/lib/core/base";
import { PrivateLocationsForPP } from "master-locations-library/master-locations-library/src/lib/core/domain/models";
import { PrivateLocationsForPPWebEntity } from "./private-locations-for-PP-web-entity";
import { OpeningHoursForPPLocationMapper } from "./opening-hours-for-PP-location-web-entity-mapper";

export class PrivateLocationsForPPMapper extends Mapper<
  PrivateLocationsForPPWebEntity,
  PrivateLocationsForPP
> {
  mapFrom(param: PrivateLocationsForPPWebEntity): PrivateLocationsForPP {
    const openingHoursForPPLocationMapper = new OpeningHoursForPPLocationMapper(); 
    return {
        id: param.id,
        name: param.name,
        locationId: param.locationId,
        longitude: param.longitude,
        latitude: param.latitude,
        address: param.address,
        postalCode: param.postalCode,
        city: param.city,
        country: param.country,
        openingHours: openingHoursForPPLocationMapper.mapFrom(param.openingHours),
        stopTime: param.stopTime,
        isInfrastructure: param.isInfrastructure,
        shouldVisitIfNoService: param.shouldVisitIfNoService,
        segment: param.segment,
        locationAdditionalInfo: param.locationAdditionalInfo,
        productAdditionalInfo: param.productAdditionalInfo,
        productName: param.productName,
        productTemplate: param.productTemplate,
        tenantLocationId: param.tenantLocationId,
        tenantKeyMapping: param.tenantKeyMapping,
        productId : param.productId,
        prodId : param.prodId,
        activityName : param.activityName, 
        day : param.day, 
        serviceStopTime : param.serviceStopTime,
        serviceFromTime :param.serviceFromTime,
        serviceToTime :param.serviceToTime,
        isEnabled :param.isEnabled ,
        pickupCapacityType1 :param.pickupCapacityType1,  
        pickupCapacityType2 :param.pickupCapacityType2,
        pickupCapacityType3 :param.pickupCapacityType3,  
        deliveryCapacityType1 :param.deliveryCapacityType1,  
        deliveryCapacityType2 :param.deliveryCapacityType2,  
        deliveryCapacityType3 :param.deliveryCapacityType3  
    };
  }

  mapTo(param: PrivateLocationsForPP): PrivateLocationsForPPWebEntity {
    const openingHoursForPPLocationMapper = new OpeningHoursForPPLocationMapper(); 
    return {
        id: param.id,
        name: param.name,
        locationId: param.locationId,
        longitude: param.longitude,
        latitude: param.latitude,
        address: param.address,
        postalCode: param.postalCode,
        city: param.city,
        country: param.country,
        openingHours: openingHoursForPPLocationMapper.mapTo(param.openingHours),
        stopTime: param.stopTime,
        isInfrastructure: param.isInfrastructure,
        shouldVisitIfNoService: param.shouldVisitIfNoService,
        segment: param.segment,
        locationAdditionalInfo: param.locationAdditionalInfo,
        productAdditionalInfo: param.productAdditionalInfo,
        productName: param.productName,
        productTemplate: param.productTemplate,
        tenantLocationId: param.tenantLocationId,
        tenantKeyMapping: param.tenantKeyMapping,
        productId : param.productId,
        prodId : param.prodId,
        activityName : param.activityName, 
        day : param.day, 
        serviceStopTime : param.serviceStopTime,
        serviceFromTime :param.serviceFromTime,
        serviceToTime :param.serviceToTime,
        isEnabled :param.isEnabled ,
        pickupCapacityType1 :param.pickupCapacityType1,  
        pickupCapacityType2 :param.pickupCapacityType2,
        pickupCapacityType3 :param.pickupCapacityType3,  
        deliveryCapacityType1 :param.deliveryCapacityType1,  
        deliveryCapacityType2 :param.deliveryCapacityType2,  
        deliveryCapacityType3 :param.deliveryCapacityType3 
    };
  }
}